require('bootstrap/js/dist/offcanvas');
require('jquery-ui/ui/widgets/slider');
require('jquery-ui/themes/base/all.css');

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
